import {
    StyleSheet
} from "react-native";

export default StyleSheet.create({
    container: {
        justifyContent: "space-between",
        alignContent: "space-between",
        alignItems: "center",
        flexShrink: 1,
        flex: 1
    },
    contentContainer: {
        width: "100%"
    },
    codeFieldRoot: {
        justifyContent: "space-between",
        alignContent: "center",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    cell: {
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center"
    },
    description: {
        textAlign: "center"
    },
    buttonsContainer: {
        width: "100%"
    }
});
